module.exports = __webpack_public_path__ + "img/sort.747bc476.svg";